/* eslint-disable vue/order-in-components */
// @ts-nocheck
import { IS_POPUP_VAR, VERSION } from "@pdfking/constants/settings"
import { merge, object_map } from "@pdfking/rfunc"
import url_read_tracked from "@pdfking/workflow/utils/url_read_tracked"
import { url_query_encode } from "@pdfking/workflow/utils/urlutilities"
import { defineComponent } from "vue"
import searchselect from "./searchselect"

export default defineComponent({
  computed: {
    results() {
      return this.search_results
    },
  },
  data() {
    return {
      hide_dropdown: true,
      loading: false,
      search_results: {},
      selection: object_map(
        i => i.id,
        i => this.add_url(i),
        this.value
      ),
    }
  },
  extends: searchselect,
  methods: {
    add_url(i, score) {
      return merge(i, {
        score: score || 0,
        url: `${this.adminurl + i.id}/`,
      })
    },
    search(q) {
      if (q.length <= 1) {
        this.search_results = {}
      } else if (!this.loading) {
        this.loading = true
        url_read_tracked(
          this.adminurl +
            "autocomplete/" +
            "?" +
            [
              url_query_encode({ [IS_POPUP_VAR]: VERSION, q }),
              this.adminfilters || "",
            ].join("&"),
          {}
        )
          .then(r => r.json())
          .then(r => {
            this.loading = false
            this.search_results = merge(
              {
                [q]: {
                  id: q,
                  score: 0,
                  unicode: `<em>${q}</em>`,
                },
              },
              object_map(
                v => v.id,
                (v, i) => this.add_url(v, i + 1),
                r.objects
              )
            )
          })
      }
    },
  },
  props: ["adminurl", "adminfilters"],
  watch: {
    query(q) {
      this.search(q)
    },
  },
})
